import { lazy, Suspense, type ComponentType } from "react";
import type { RouteObject } from "react-router-dom";

const page = (loader: () => Promise<{ default: ComponentType }>) => {
  const Page = lazy(loader);
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-background-50 flex items-center justify-center" role="status">
          <span className="sr-only">Seite wird geladen</span>
        </div>
      }
    >
      <Page />
    </Suspense>
  );
};

const routes: RouteObject[] = [
  { path: "/", element: page(() => import("../pages/home/page")) },
  { path: "/videoüberwachung", element: page(() => import("../pages/videoüberwachung/page")) },
  { path: "/lösungen", element: page(() => import("../pages/lösungen/page")) },
  { path: "/privatkunden", element: page(() => import("../pages/privatkunden/page")) },
  { path: "/gewerbekunden", element: page(() => import("../pages/gewerbekunden/page")) },
  { path: "/einzelhandel-gastronomie", element: page(() => import("../pages/einzelhandel-gastronomie/page")) },
  { path: "/buero-praxis", element: page(() => import("../pages/buero-praxis/page")) },
  { path: "/lager-logistik", element: page(() => import("../pages/lager-logistik/page")) },
  { path: "/werkstatt-gewerbe", element: page(() => import("../pages/werkstatt-gewerbe/page")) },
  { path: "/mehrfamilien-immobilien", element: page(() => import("../pages/mehrfamilien-immobilien/page")) },
  { path: "/ssg-care", element: page(() => import("../pages/ssg-care/page")) },
  { path: "/alarmanlagen", element: page(() => import("../pages/alarmanlagen/page")) },
  { path: "/servicegebiete", element: page(() => import("../pages/servicegebiete/page")) },
  { path: "/sicherheitskamera-offenbach", element: page(() => import("../pages/standorte/page")) },
  { path: "/sicherheitskamera-frankfurt", element: page(() => import("../pages/standorte/page")) },
  { path: "/sicherheitskamera-darmstadt", element: page(() => import("../pages/standorte/page")) },
  { path: "/sicherheitskamera-hanau", element: page(() => import("../pages/standorte/page")) },
  { path: "/kameraplaner", element: page(() => import("../pages/kameraplaner/page")) },
  { path: "/über-uns", element: page(() => import("../pages/über-uns/page")) },
  { path: "/faq", element: page(() => import("../pages/faq/page")) },
  { path: "/kontakt", element: page(() => import("../pages/kontakt/page")) },
  { path: "/impressum", element: page(() => import("../pages/impressum/page")) },
  { path: "/datenschutz", element: page(() => import("../pages/datenschutz/page")) },
  { path: "*", element: page(() => import("../pages/NotFound")) },
];

export default routes;
